import { AllProducts } from 'types/product-data'
import axios from 'axios'
import { GetProductsResponse, BoltApiResponseBody } from 'types/bolt-api/request'

/**
 * Get all products
 *
 * @returns {Promise<AllProducts | undefined>}
 */
const getProducts = async (): Promise<AllProducts | undefined> => {
  try {
    const response = await axios.get<BoltApiResponseBody<GetProductsResponse>>(`${process.env.API_URL}/products`)
    const {
      data: { success, data }
    } = response

    return success && data?.products ? data.products : undefined
  } catch (_) {
    return undefined
  }
}

export default getProducts
